import { render, staticRenderFns } from "./analysis-roles-avatars.vue?vue&type=template&id=e5345e30"
import script from "./analysis-roles-avatars.vue?vue&type=script&lang=ts"
export * from "./analysis-roles-avatars.vue?vue&type=script&lang=ts"
import style0 from "./analysis-roles-avatars.vue?vue&type=style&index=0&id=e5345e30&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5345e30')) {
      api.createRecord('e5345e30', component.options)
    } else {
      api.reload('e5345e30', component.options)
    }
    module.hot.accept("./analysis-roles-avatars.vue?vue&type=template&id=e5345e30", function () {
      api.rerender('e5345e30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-user-role-avatar/analysis-roles-avatars.vue"
export default component.exports